// extracted by mini-css-extract-plugin
module.exports = {"store":"StoreSelection_store__w6wTE","chevron_icon":"StoreSelection_chevron_icon__6tfe6"};